import { render, staticRenderFns } from "./IconDefault.vue?vue&type=template&id=7a040fea&scoped=true&"
import script from "./IconDefault.vue?vue&type=script&lang=js&"
export * from "./IconDefault.vue?vue&type=script&lang=js&"
import style0 from "./IconDefault.vue?vue&type=style&index=0&id=7a040fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a040fea",
  null
  
)

export default component.exports